export const DEFAULT_STORY_DURATION_SECONDS = 5;
export const MIN_STORY_DURATION_SECONDS = 2;
export const MAX_STORY_DURATION_SECONDS = 150;

const clampStoryDuration = (seconds: number): number =>
  Math.min(MAX_STORY_DURATION_SECONDS, Math.max(MIN_STORY_DURATION_SECONDS, Math.round(seconds)));

export const resolveStoryDuration = (durationSeconds?: number | null): number => {
  if (typeof durationSeconds !== 'number' || !Number.isFinite(durationSeconds)) {
    return DEFAULT_STORY_DURATION_SECONDS;
  }
  return clampStoryDuration(durationSeconds);
};

export const resolveStoryDurationMs = (durationSeconds?: number | null): number =>
  resolveStoryDuration(durationSeconds) * 1000;
